export default __webpack_public_path__ + "static/media/SG-Yellow-0007.bd299d41.png";